/* eslint-disable react/prop-types */
import dayjs from 'dayjs'
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/pt-br'

interface CustomTimePickerProps extends React.ComponentProps<typeof TimePicker> {
	isWarning?: boolean
}

const CustomTimePicker: React.FC<CustomTimePickerProps> = ({ isWarning = false, ...props }) => {
	return (
		<LocalizationProvider
			dateAdapter={AdapterDayjs}
			adapterLocale='pt-br'
		>
			<div onClick={e => e.stopPropagation()}>
				<TimePicker
					ampm={false}
					timeSteps={{ hours: 1, minutes: 1 }}
					views={['hours', 'minutes']}
					// referenceDate: quando value é null, o MUI usa este valor como base para o input por secções (hh:mm).
					// Sem isto, escrever apenas as horas fazia o campo resetar para "--:--" ao mudar de secção.
					referenceDate={dayjs().startOf('day')}
					slotProps={{
						textField: {
							sx: {
								borderRadius: 0,
								margin: 0,
								borderColor: 'transparent',
								transition: 'border-color 0.2s',
								'& .MuiInputBase-root': {
									width: '72px',
									color: isWarning ? 'var(--warning)' : 'var(--primary-dark)',
									padding: 0,
									'& fieldset': {
										borderRadius: 0,
										borderColor: 'transparent',
									},
								},
								'& input': {
									width: '43px',
									color: isWarning ? 'var(--warning)' : 'var(--primary-dark)',
									backgroundColor: 'rgba(245, 247, 252, 0.5)',
									fontFamily: 'Poppins',
									fontSize: '0.75rem',
									padding: '1.375px 4px',
								},
								'& .MuiInputAdornment-positionEnd': {
									width: '20px',
									margin: 0,
								},
								'& button': {
									color: 'var(--primary)',
									backgroundColor: 'rgba(245, 247, 252, 0.5)',
									borderRadius: 0,
									minWidth: 0,
									minHeight: 0,
									width: '20px',
									height: '20px',
									padding: 0,
									margin: 0,
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									boxSizing: 'border-box',
								},
								'& button svg': {
									width: '14px',
									height: '14px',
								},
								'& .MuiOutlinedInput-root fieldset': {
									padding: 0,
									borderRadius: 0,
									borderColor: 'transparent',
								},
								'& .MuiOutlinedInput-root:hover fieldset': {
									borderColor: 'transparent',
								},
								'& .MuiOutlinedInput-root.Mui-focused fieldset': {
									borderColor: 'transparent',
								},
								'& .MuiOutlinedInput-root.Mui-disabled fieldset': {
									borderColor: 'transparent',
								},
								'& .MuiOutlinedInput-root.Mui-error fieldset': {
									borderColor: 'transparent',
								},
								'&:hover': {
									borderColor: 'transparent',
									color: isWarning ? 'var(--warning)' : 'var(--primary-dark)',
								},
								'&.Mui-focused': {
									borderColor: 'transparent',
									color: isWarning ? 'var(--warning)' : 'var(--primary-dark)',
								},
								'&.Mui-disabled': {
									borderColor: 'transparent',
								},
								'&.Mui-error': {
									borderColor: 'transparent',
									color: isWarning ? 'var(--warning)' : 'var(--primary-dark)',
								},
							},
						},
						popper: {
							disablePortal: props.disabled ? true : false,
							sx: {
								'& .MuiButtonBase-root': {
									color: 'var(--primary-dark)',
									fontFamily: 'Poppins',
									fontSize: '0.75rem',
									padding: '4px 8px',
									borderRadius: 0,
									textTransform: 'none',
									'&.Mui-selected': {
										backgroundColor: 'rgba(245, 247, 252, 0.5)',
										color: '#fff',
									},
								},
							},
						},
					}}
					{...props}
				/>
			</div>
		</LocalizationProvider>
	)
}

export default CustomTimePicker
